const COLUMNS_292 = ['first_name', 'last_name', 'reconnection_minutes'];
export function isMissingComms292Column(error) {
    const text = `${error?.message || ''} ${error?.details || ''} ${error?.hint || ''}`;
    return ['42703', 'PGRST204'].includes(error?.code) && COLUMNS_292.some(column => text.includes(column));
}
export function withoutComms292Columns(value) {
    if (typeof value === 'string') return value.split(',').map(s => s.trim()).filter(column => !COLUMNS_292.includes(column)).join(', ');
    if (Array.isArray(value)) return value.map(withoutComms292Columns);
    return Object.fromEntries(Object.entries(value || {}).filter(([key]) => !COLUMNS_292.includes(key)));
}
// Retry only a missing-column response. Failed statements did not mutate a row.
export async function withComms292Fallback(run, columns, payload) {
    const result = await run(columns, payload);
    return isMissingComms292Column(result.error)
        ? run(withoutComms292Columns(columns), payload === undefined ? undefined : withoutComms292Columns(payload)) : result;
}
